import AccessManagement from './AccessManagement';

export default AccessManagement;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/AccessManagement/index.js